import { render, staticRenderFns } from "./LegalCenter.vue?vue&type=template&id=76a47a7e&scoped=true"
import script from "./LegalCenter.vue?vue&type=script&lang=js"
export * from "./LegalCenter.vue?vue&type=script&lang=js"
import style0 from "./LegalCenter.vue?vue&type=style&index=0&id=76a47a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a47a7e",
  null
  
)

export default component.exports